import { Panel } from '@xyflow/react';
import WarningsButton from './WarningsButton';
import BalanceButton from './BalanaceButton';
import AnalysisButton from './AnalysisButton';
import OpenAnalysisButton from './OpenAnalysisButton';
import ExitInternalsViewButton from './ExitInternalsViewButton';
import SaveInternalsButton from './SaveInternalsButton';

const PathwayPanel = () => {
  return (
    <Panel className="mr-60 flex gap-4" position="bottom-right">
      <WarningsButton />
      <SaveInternalsButton />
      <ExitInternalsViewButton />
      <BalanceButton />
      <AnalysisButton />
      <OpenAnalysisButton />
    </Panel>
  );
};

export default PathwayPanel;
